import { formatCurrency } from 'utils/CurrencyUtils';

import type { HTMLAttributes } from 'react';
import type { ItemBaseOfOrderTotals } from 'shared/domain';

export function ItemOfOrderTotals(props: Props) {
  const { item, ...restProps } = props;
  return (
    <div aria-label={item.id} {...restProps}>
      <p>{item.label}</p>
      <p>{formatCurrency(item.price, false)}</p>
    </div>
  );
}

interface Props extends HTMLAttributes<HTMLDivElement> {
  item: ItemBaseOfOrderTotals;
}
